/**
 * Created by mauget on 2/2/16. Groundhog Day.
 */

// ThemeModel.js

import { Model } from 'backbone';
import _ from 'lodash';
import formModel 		from 'formModel.js'
import constants from 'Constants.js';
import Immutable from 'immutable';
import themeService from 'ThemeService.js';
import undoService from 'UndoService.js'
import pageSyncService  from 'PageSyncService.js';
import listService  from 'ListService.js';
import textConstants        from 'TextConstants';
import eventBus from 'EventBus.js';

//=====================================================================================
// This model contains the current theme state
//
// Lou Mauget, February 2, 2016 -- Happy Groundhog Day.
//=====================================================================================
class ThemeModel extends Model {

    initialize() {

        this.initDevice = {
            formHeight: this.get('formHeight'),
            formWidth: this.get('formWidth')
        }

        this.on('change:formHeight', function(){
            this.set( { [formModel.get('currentDevice')]: { formWidth: this.get('formWidth'), formHeight: this.get('formHeight') }});
        });

        this.on('change:formWidth', function(){
            this.set( { [formModel.get('currentDevice')]: { formWidth: this.get('formWidth'), formHeight: this.get('formHeight') }});
        });

        var control = this;
        formModel.on('change:currentDevice', function(){
            // hitting attributes directly instead of using getter to
            // access dynamic currentDevice value
            control.set( control.attributes[this.attributes.currentDevice] );
        });

      this.lastState(this.toJSON());

      this.set('undoAction', false, {silent: true});

      this.on('change', function () {
            if (this.get('undoAction')) {
                this.set('undoAction', false, {silent: true});
                this.lastState(this.toJSON());
            } else {
                const lastState = this._lastState;
                try {
                    const newState = JSON.stringify(this);
                } catch (err) {
                    console.log(`ThemeModel onChange record undo/redo action error`);
                }

                const mapReviver = this.getMapReviver();

                undoService.add({
                    undo: () => {
                        // we load the saved version//
                        let previousState = JSON.parse(lastState, mapReviver);
                        if (!previousState['fieldName']) {////
                            this.set('fieldName', '', {silent: true});
                            this.set('selectedFieldName', '', {silent: true});
                        }

                        if (!previousState.Parameters) {
                            this.attributes.Parameters = {};

                            let Parameter = {
                                id: this.modelField,
                                type: 'literal',
                                literal: '',
                                field: 'null',
                                special: 'stage'
                            };

                            this.attributes.Parameters.Parameter = [Parameter];
                        }

                        this.set(previousState, {silent: true});
                        // we want to ignore what was set for this, this is important to not register another undo
                        this.set('undoAction', true, {silent: true});
                        // we trigger change because all views listening need to update

                        eventBus.trigger('formWidthSet', this.get('formWidth'));
                        eventBus.trigger('formHeightSet', this.get('formHeight'));
                        eventBus.trigger('dropShadowSet', this.get('shadow'));
                        eventBus.trigger('gridWidthSet', this.get('gridWidth'));
                        eventBus.trigger('gridHeightSet', this.get('gridHeight'));
                        this.trigger('change');

                    },
                    redo: () => {
                        // we load the saved version
                        this.set(JSON.parse(newState, mapReviver), {silent: true});
                        // we want to ignore what was set for this, this is important to not register another undo
                        this.set('undoAction', true, {silent: true});


                        eventBus.trigger('formWidthSet', this.get('formWidth'));
                        eventBus.trigger('formHeightSet', this.get('formHeight'));
                        eventBus.trigger('dropShadowSet', this.get('shadow'));
                        eventBus.trigger('gridWidthSet', this.get('gridWidth'));
                        eventBus.trigger('gridHeightSet', this.get('gridHeight'));
                        this.trigger('change');
                    }
                }, textConstants.UNDO_FORM_CHANGE);

                this.lastState(this.toJSON());
            }

      });

        this.set( {
            deviceDesktop: this.initDevice,
            behaviorCount: 0,
            objectCount: 0,
            objects: [],
            behaviors: []
        },{silent:true} );

    }

    resetTheme() {
        themeService.reset();
        const theme = this.defaults()
        _.forEach( theme, (value, name) => {
            this.set( name, value );
        });
    }

    defaults() {
        const attrs = themeService.theme;
        attrs.name = 'Form';
        attrs.factoryKey = 'layout_frame';
        return attrs;
    }

    getMapReviver() {
        return (key, value) => {
            var serializedValue = value;
            if (key === 'mandatories' || key === 'state') {
                serializedValue = new Map(value);
            }
            return serializedValue;
        };
    }

    lastState(state) {
        try {
            this._lastState = JSON.stringify(state);
        } catch( err ) {
            console.log(`lastState error`);
        }
    }


    parse(response, options) {
        return response;
    }

}

export default ThemeModel;
